import React from "react";

/**
 * Generic Button Component
 * @param {Object} props
 * @param {string} props.id
 * @param {string} [props.className=""]
 * @param {string} props.text
 * @param {function} props.onClick
 * @param {boolean} [props.disabled=false]
 * @param {string} props.title
 * @param {boolean} [props.small=false]
 * @returns {React.JSX.Element}
 */
export default function Button({ id, className = "", text, onClick, disabled = false, title, small = false }) {
  return (
    <button
      id={id}
      className={`${small ? "btn-small" : "btn"} ${className}`}
      disabled={disabled}
      onClick={onClick}
      title={title}
    >
      {text}
    </button>
  );
}
